/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { Users } from '@codegrade/icons';
import { Maybe } from '@codegrade/maybe';
import { DescriptionPopover } from '@/components/Popover';
import { UserStore } from '@/store';
import * as utils from '@/utils';
const DisplayName = tsx.component({
    name: 'user-diplay-name',
    functional: true,
    props: {
        user: p.ofType().required,
        group: p.ofType().required,
        title: p(String).optional,
        assignment: p.ofType().required,
        loggedIn: p.ofType().required,
    },
    /**
     * Render the display name component.
     *
     * @param h The way to create elements.
     * @param ctx The context of the component.
     * @returns A node containing the display name of the user.
     */
    render(h, ctx) {
        return utils.user.displayName({ ...ctx.props, prefixGroup: false }).caseOf({
            Just: content => h(utils.user.shouldAnonymize(ctx.props) ? 'i' : 'span', {
                class: ctx.data.class,
                staticClass: ctx.data.staticClass,
                staticStyle: ctx.data.staticStyle,
                style: ctx.data.style,
                attrs: {
                    title: ctx.props.title,
                },
            }, content),
            Nothing: () => (<i class={[ctx.data.class, ctx.data.staticClass]} style={[ctx.data.style, ctx.data.staticStyle]} title={ctx.props.title}>
                    Unknown
                </i>),
        });
    },
});
export default tsx.component({
    name: 'user',
    functional: true,
    props: {
        user: p.ofType().required,
        beforeGroup: p(String).default('Group'),
        showTitle: p(Boolean).default(false),
        showWhenYou: p.ofType().default(undefined),
        showYou: p(Boolean).default(false),
        anonymizeFor: p.ofType().optional,
        withUsername: p(Boolean).default(false),
        hideMembers: p(Boolean).default(false),
        inline: p(Boolean).default(false),
        memberClasses: p(String).optional,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const loggedIn = UserStore.loggedInUser();
        const ownId = loggedIn.map(u => u.id).orDefault(0);
        const assignment = Maybe.fromNullable(ctx.props.anonymizeFor);
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderUser = (user, groupOfUser) => {
            const isSelf = user.id === ownId;
            const maybeTestUserStyle = user.isTestStudent && 'italic font-medium underline decoration-dotted';
            const maybeTestUserTitle = user.isTestStudent ? 'This is a test student' : undefined;
            return [
                utils.ifExpr(ctx.props.showWhenYou != null && isSelf, () => ctx.props.showWhenYou, () => [
                    <DisplayName user={user} assignment={assignment} group={groupOfUser} loggedIn={loggedIn} class={['name-user text-break', maybeTestUserStyle]} title={maybeTestUserTitle}/>,
                    utils.ifOrEmpty(ctx.props.showYou && isSelf, () => (<span class="user-you-text font-italic"> (You)</span>)),
                    utils.ifOrEmpty(ctx.props.withUsername, () => (<span class={['user-username', maybeTestUserStyle]} title={maybeTestUserTitle}>
                                {' '}
                                ({user.username})
                            </span>)),
                ]),
            ];
        };
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderGroup = (user) => [
            <span class="group-name">
                {ctx.props.beforeGroup} "
                <DisplayName user={user} assignment={assignment} group={Maybe.empty()} loggedIn={loggedIn}/>
                "
            </span>,
            utils.ifOrEmpty(!ctx.props.hideMembers, () => {
                const members = user.group.members;
                const maybeOfGroup = Maybe.of(user.group);
                return (<DescriptionPopover hug-text span-title="Click to show the users of this group" ariaLabel="More information about this group" title="Group members" icon={Users} class={ctx.props.memberClasses}>
                        {members.length > 0 ? (<ul class="users-list mb-0 ml-0 pl-3">
                                {members.map(member => (<li key={member.id}>{renderUser(member, maybeOfGroup)}</li>))}
                            </ul>) : ('This group has no members.')}
                    </DescriptionPopover>);
            }),
        ];
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const renderInner = (user) => {
            if (user.type === 'group-user') {
                return renderGroup(user);
            }
            else {
                return renderUser(user, Maybe.empty());
            }
        };
        let title;
        if (ctx.props.showTitle ||
            (ctx.props.user.type === 'normal' && ctx.props.user.name.isNothing())) {
            title = utils.user
                .displayName({
                user: ctx.props.user,
                assignment: Maybe.fromNullable(ctx.props.anonymizeFor),
                group: Maybe.empty(),
                loggedIn,
            })
                .orDefault('We are not allowed permanently store the name of the user, and we cannot retrieve the name of this user anymore.');
        }
        return (<span class={[
                'user',
                ctx.props.inline ? 'd-inline' : 'd-inline-block',
                ctx.data.class,
                ctx.data.staticClass,
            ]} title={title}>
                {renderInner(ctx.props.user)}
            </span>);
    },
});
